import React, { useState } from 'react';
import classNames from 'classnames';
import { trackFeatureUsage } from '@animoto/utils/analytics';
import {
  Button,
  HeaderExtraSmall,
  Overlay,
  overlayTypes,
  ToastPanel,
  toastPanelAlignments
} from '@animoto/components/lib/es/design-system';

import {
  button,
  content,
  overlay,
  text
} from './OwnerToast.module.css';

export default function OwnerToast() {
  const [isOverlayVisible, setIsOverlayVisible] = useState(true);
  const onClickButton = () => {
    trackFeatureUsage({
      scope   : 'visitor-play-page',
      feature : 'owner-share-toast',
      action  : 'click:share-page'
    });
  };
  const onOverlayClick = () => {
    setIsOverlayVisible(false);
    trackFeatureUsage({
      scope   : 'visitor-play-page',
      feature : 'owner-share-toast',
      action  : 'click:dismiss-overlay'
    });
  };
  const buttonClasses = classNames('s-toast-button', button);
  return (
    <>
      <ToastPanel
        alignment={toastPanelAlignments.RIGHT}
        isDismissable={false}
        isOpen
      >
        <div className={content}>
          <HeaderExtraSmall className={text}>This is the video page your viewers will see.</HeaderExtraSmall>
          <Button
            className={buttonClasses}
            href={`/share/${window.location.href.split('/').pop()}`}
            onClick={onClickButton}
          >
            Share video
          </Button>
        </div>
      </ToastPanel>
      {isOverlayVisible && (
        <div
          aria-label="Overlay"
          className="s-overlay-wrap"
          onClick={onOverlayClick}
          role="button"
          tabIndex={0}
        >
          <Overlay className={overlay} type={overlayTypes.DARK} />
        </div>
      )}
    </>
  );
}
